import { createContext, useContext, useMemo, useState, ReactNode } from "react";

export type EslPreviewMode = "design" | "colorScreen" | "redAndBlackScreen";

interface EslPreviewModeContextValue {
    mode: EslPreviewMode;
    setMode: (mode: EslPreviewMode) => void;
}

const EslPreviewModeContext = createContext<EslPreviewModeContextValue>({
    mode: "design",
    setMode: () => undefined,
});

interface EslPreviewModeProviderProps {
    children: ReactNode;
    initialMode?: EslPreviewMode;
}

export const EslPreviewModeProvider = ({ children, initialMode = "design" }: EslPreviewModeProviderProps) => {
    const [mode, setMode] = useState<EslPreviewMode>(initialMode);
    const value = useMemo(() => ({ mode, setMode }), [mode]);

    return <EslPreviewModeContext.Provider value={value}>{children}</EslPreviewModeContext.Provider>;
};

export const useEslPreviewMode = () => useContext(EslPreviewModeContext);
